// extracted by mini-css-extract-plugin
module.exports = {"validationFailures":"Form-validationFailures-3VMpe"};